import React, { ReactNode } from 'react';

import { Container } from './HelperModal.styled';
import { Modal } from 'components/v2/Modal/Modal';
import { Text } from 'components/v2/Typography/Text';

type Props = {
  title: string;
  copy?: ReactNode;
  content?: ReactNode;
  open: boolean;
  onDismiss: () => void;
};

export const HelperModal = ({ title, copy, open, content, onDismiss }: Props) => {
  return (
    <Modal title={title} open={open} onCancel={onDismiss}>
      <Container data-testid="helper-modal-container">
        <Text>{copy}</Text>
        {content}
      </Container>
    </Modal>
  );
};

export default HelperModal;
